export const BUSINESS_BILL_PAY_PAYEE_DETAIL_CONTAINER_TAG_NAME =
    'business-bill-pay-payee-detail-container';
